import React, { useState, useContext, memo, Fragment, useEffect, useMemo } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Accordion, useAccordionButton, AccordionContext } from 'react-bootstrap'
import SignatureRolloutService from '../../../../services/signature/SignatureRolloutService'
import NotificationService from '../../../../services/notification/NotificationService';
import SidebarIcon from './SidebarIcon';


function CustomToggle({ children, eventKey, onClick }) {

    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(eventKey, (active) => onClick({ state: !active, eventKey: eventKey }));

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
        <Link to="#" aria-expanded={isCurrentEventKey ? 'true' : 'false'} className="nav-link" role="button" onClick={(e) => {
            decoratedOnClick(isCurrentEventKey)
        }}>
            {children}
        </Link>
    );
}

const VerticalNav = memo((props) => {
    const [activeMenu, setActiveMenu] = useState(false)
    const [active, setActive] = useState('')
    const [approvalUnreadCount, setApprovalUnreadCount] = useState(0)
    const [signatureUnreadCount, setSignatureUnreadCount] = useState(0)
    const [signatureRequired, setSignatureRequired] = useState(false)
    const [signaturePolicyLoaded, setSignaturePolicyLoaded] = useState(false)

    let notificationService = useMemo(() => new NotificationService(), [])

    useEffect(() => {
        let mounted = true

        const loadNotificationCounts = async () => {
            try {
                const policyResponse = await SignatureRolloutService.getMyPolicy()
                const policy = policyResponse?.data?.data || policyResponse?.data || {}
                const required = policy.signatureRequired === true
                if (mounted) {
                    setSignatureRequired(required)
                    setSignaturePolicyLoaded(true)
                }

                const approvalResponse = await notificationService.unreadCount('DOCUMENT_APPROVAL_REQUIRED')
                let signatureResponse = { data: { count: 0 } }
                if (required) {
                    signatureResponse = await notificationService.unreadCount('SIGNATURE_REQUIRED')
                }

                if (mounted) {
                    setApprovalUnreadCount(Number(approvalResponse.data?.count || 0))
                    setSignatureUnreadCount(Number(signatureResponse.data?.count || 0))
                }
            } catch (_) {
                if (mounted) {
                    setSignatureRequired(false)
                    setSignaturePolicyLoaded(true)
                    setApprovalUnreadCount(0)
                    setSignatureUnreadCount(0)
                }
            }
        }

        loadNotificationCounts()

        const timer = setInterval(
            loadNotificationCounts,
            60000
        )

        return () => {
            mounted = false
            clearInterval(timer)
        }
    }, [notificationService])
    //location
    let location = useLocation();
    let role = localStorage.getItem("role")
    let isMandatoryPrimer = localStorage.getItem("isMandatoryPrimer")
    let isMandatoryPasca = localStorage.getItem("isMandatoryPasca")
    // let kodeTrader = localStorage.getItem("kodeTrader")
    // let kdUnit = localStorage.getItem("kdUnit")
    return (
        <Fragment>
            <Accordion as="ul" className="navbar-nav iq-main-menu pb-5">
                <li className="nav-item">
                    <Link className={`${location.pathname.startsWith('/pengumuman') ? 'active' : ''} nav-link`} to="/pengumuman">
                        <i className="icon"><SidebarIcon name="megaphone" size={20} /></i>
                        <i className="sidenav-mini-icon"> P </i>
                        <span className="item-name">Pusat Pengumuman</span>
                    </Link>
                </li>
                {(role === "1" || role === "2" || role === "3" || role === "7") && <>
                    <Accordion.Item as="li" eventKey="sidebar-dashboard" bsPrefix={`nav-item ${active === 'dashboard' ? 'active' : ''} `} onClick={() => setActive('dashboard')}>
                        <CustomToggle eventKey="sidebar-dashboard" active={activeMenu === 'sidebar-dashboard'} onClick={() => setActiveMenu(activeMenu === 'sidebar-dashboard' ? null : 'sidebar-dashboard')}>
                            <i className="icon"><SidebarIcon name="dashboard" size={20} /></i>
                            <Link
                                to="/dashboard"
                                className={`item-name ms-2 nav-link no-after ${activeMenu === 'sidebar-dashboard' ? 'text-white' : ''}`}
                                onClick={(e) => {
                                    setActive('dashboard');
                                    setActiveMenu(activeMenu === 'sidebar-dashboard' ? null : 'sidebar-dashboard');
                                }}
                            >
                                Dashboard
                            </Link>
                            <i className="right-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                </svg>
                            </i>
                        </CustomToggle>
                        <Accordion.Collapse eventKey="sidebar-dashboard">
                            <ul className="sub-nav">
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/dashboard/primer' ? 'active' : ''} nav-link`} to="/dashboard/primer">
                                        <i className="icon"><SidebarIcon name="chartPie" size={16} /></i>
                                        <i className="sidenav-mini-icon"> U </i>
                                        <span className="item-name">SM Primer</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/dashboard/pasca' ? 'active' : ''} nav-link`} to="/dashboard/pasca">
                                        <i className="icon"><SidebarIcon name="chartBar" size={16} /></i>
                                        <i className="sidenav-mini-icon"> E </i>
                                        <span className="item-name">SM Pasca Panen</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/dashboard/ekspor' ? 'active' : ''} nav-link`} to="/dashboard/ekspor">
                                        <i className="icon"><SidebarIcon name="globe" size={16} /></i>
                                        <i className="sidenav-mini-icon"> U </i>
                                        <span className="item-name">Ekspor</span>
                                    </Link>
                                </li>
                            </ul>
                        </Accordion.Collapse>
                    </Accordion.Item>
                </>
                }
                {(role === "1" || role === "2" || role === "3" || role === "6" || role === "7") && <>
                    <li><hr className="hr-horizontal" /></li>
                    <li className="nav-item static-item">
                        <Link className="nav-link static-item disabled" to="#" tabIndex="-1">
                            <span className="default-icon text-secondary">Sertifikasi Primer</span>
                            <span className="mini-icon">-</span>
                        </Link>
                    </li>
                    <Accordion.Item as="li" eventKey="sidebar-auth" bsPrefix={`nav-item ${active === 'auth' ? 'active' : ''} `} onClick={() => setActive('auth')}>
                        <CustomToggle eventKey="sidebar-auth" active={activeMenu === 'sidebar-auth' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                            <i className="icon"><SidebarIcon name="badgeCheck" size={20} /></i>
                            <span className="item-name">Primer</span>
                            <i className="right-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                </svg>
                            </i>
                        </CustomToggle>
                        <Accordion.Collapse eventKey="sidebar-auth">
                            <ul className="sub-nav">
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/pbumku/daftar-primer' ? 'active' : ''} nav-link`} to="/pbumku/daftar-primer">
                                        <i className="icon"><SidebarIcon name="fileText" size={16} /></i>
                                        <i className="sidenav-mini-icon"> B </i>
                                        <span className="item-name">Daftar Permohonan</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/pbumku/dokumen-checklist' ? 'active' : ''} nav-link`} to="/pbumku/dokumen-checklist">
                                        <i className="icon"><SidebarIcon name="listCheck" size={16} /></i>
                                        <i className="sidenav-mini-icon"> M </i>
                                        <span className="item-name">Template Checklist</span>
                                    </Link>
                                </li>
                            </ul>
                        </Accordion.Collapse>
                    </Accordion.Item>
                    {
                        (role === "1" || role === "6" || isMandatoryPrimer === 'Y') && <>
                            <Accordion.Item as="li" eventKey="sidebar-cpib" bsPrefix={`nav-item ${active === 'cpib' ? 'active' : ''} `} onClick={() => setActive('cpib')}>
                                <CustomToggle eventKey="sidebar-cpib" active={activeMenu === 'sidebar-cpib' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                                    <i className="icon"><SidebarIcon name="egg" size={20} /></i>
                                    <span className="item-name">CPIB</span>
                                    <i className="right-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                        </svg>
                                    </i>
                                </CustomToggle>
                                <Accordion.Collapse eventKey="sidebar-cpib">
                                    <ul className="sub-nav">
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cpib/daftar' ? 'active' : ''} nav-link`} to="/pbumku/cpib/daftar">
                                                <i className="icon"><SidebarIcon name="inbox" size={16} /></i>
                                                <i className="sidenav-mini-icon"> P </i>
                                                <span className="item-name">Permohonan (OSS)</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cpib/daftar-manual' ? 'active' : ''} nav-link`} to="/pbumku/cpib/daftar-manual">
                                                <i className="icon"><SidebarIcon name="inbox" size={16} /></i>
                                                <i className="sidenav-mini-icon"> P </i>
                                                <span className="item-name">Permohonan (Non OSS)</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cpib/evaluasi-dok' ? 'active' : ''} nav-link`} to="/pbumku/cpib/evaluasi-dok">
                                                <i className="icon"><SidebarIcon name="searchCheck" size={16} /></i>
                                                <i className="sidenav-mini-icon"> P </i>
                                                <span className="item-name">Verifikasi (Non OSS)</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cpib/inspeksi' ? 'active' : ''} nav-link`} to="/pbumku/cpib/inspeksi">
                                                <i className="icon"><SidebarIcon name="search" size={16} /></i>
                                                <i className="sidenav-mini-icon"> P </i>
                                                <span className="item-name">Inspeksi CPIB</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cpib/reviu-rekom' ? 'active' : ''} nav-link`} to="/pbumku/cpib/reviu-rekom">
                                                <i className="icon"><SidebarIcon name="review" size={16} /></i>
                                                <i className="sidenav-mini-icon"> P </i>
                                                <span className="item-name">Reviu & Rekom Teknis</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cpib/approval' ? 'active' : ''} nav-link`} to="/pbumku/cpib/approval">
                                                <i className="icon"><SidebarIcon name="stamp" size={16} /></i>
                                                <i className="sidenav-mini-icon"> P </i>
                                                <span className="item-name">Persetujuan</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cpib/terbit' ? 'active' : ''} nav-link`} to="/pbumku/cpib/terbit">
                                                <i className="icon"><SidebarIcon name="award" size={16} /></i>
                                                <i className="sidenav-mini-icon"> P </i>
                                                <span className="item-name">Terbit</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cpib/tolak' ? 'active' : ''} nav-link`} to="/pbumku/cpib/tolak">
                                                <i className="icon"><SidebarIcon name="xCircle" size={16} /></i>
                                                <i className="sidenav-mini-icon"> P </i>
                                                <span className="item-name">Tolak</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </Accordion.Collapse>
                            </Accordion.Item>
                            <Accordion.Item as="li" eventKey="sidebar-cbib" bsPrefix={`nav-item ${active === 'cbib' ? 'active' : ''} `} onClick={() => setActive('cbib')}>
                                <CustomToggle eventKey="sidebar-cbib" active={activeMenu === 'sidebar-cbib' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                                    <i className="icon"><SidebarIcon name="pond" size={20} /></i>
                                    <span className="item-name">CBIB</span>
                                    <i className="right-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                        </svg>
                                    </i>
                                </CustomToggle>
                                <Accordion.Collapse eventKey="sidebar-cbib">
                                    <ul className="sub-nav">
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cbib/daftar' ? 'active' : ''} nav-link`} to="/pbumku/cbib/daftar">
                                                <i className="icon"><SidebarIcon name="inbox" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Permohonan (OSS)</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cbib/daftar-manual' ? 'active' : ''} nav-link`} to="/pbumku/cbib/daftar-manual">
                                                <i className="icon"><SidebarIcon name="inbox" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Permohonan (Non OSS)</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cbib/evaluasi-dok' ? 'active' : ''} nav-link`} to="/pbumku/cbib/evaluasi-dok">
                                                <i className="icon"><SidebarIcon name="searchCheck" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Verifikasi (Non OSS)</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cbib/inspeksi' ? 'active' : ''} nav-link`} to="/pbumku/cbib/inspeksi">
                                                <i className="icon"><SidebarIcon name="search" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Inspeksi CBIB</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cbib/reviu-rekom' ? 'active' : ''} nav-link`} to="/pbumku/cbib/reviu-rekom">
                                                <i className="icon"><SidebarIcon name="review" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Reviu & Rekom Teknis</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cbib/approval' ? 'active' : ''} nav-link`} to="/pbumku/cbib/approval">
                                                <i className="icon"><SidebarIcon name="stamp" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Persetujuan</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cbib/terbit' ? 'active' : ''} nav-link`} to="/pbumku/cbib/terbit">
                                                <i className="icon"><SidebarIcon name="award" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Terbit</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cbib/tolak' ? 'active' : ''} nav-link`} to="/pbumku/cbib/tolak">
                                                <i className="icon"><SidebarIcon name="xCircle" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Tolak</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </Accordion.Collapse>
                            </Accordion.Item>
                            <Accordion.Item as="li" eventKey="sidebar-cppib" bsPrefix={`nav-item ${active === 'cppib' ? 'active' : ''} `} onClick={() => setActive('cppib')}>
                                <CustomToggle eventKey="sidebar-cppib" active={activeMenu === 'sidebar-cppib' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                                    <i className="icon"><SidebarIcon name="sack" size={20} /></i>
                                    <span className="item-name">CPPIB</span>
                                    <i className="right-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                        </svg>
                                    </i>
                                </CustomToggle>
                                <Accordion.Collapse eventKey="sidebar-cppib">
                                    <ul className="sub-nav">
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cppib/daftar' ? 'active' : ''} nav-link`} to="/pbumku/cppib/daftar">
                                                <i className="icon"><SidebarIcon name="inbox" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Permohonan (OSS)</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cppib/inspeksi' ? 'active' : ''} nav-link`} to="/pbumku/cppib/inspeksi">
                                                <i className="icon"><SidebarIcon name="search" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Inspeksi CPPIB</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cppib/reviu-rekom' ? 'active' : ''} nav-link`} to="/pbumku/cppib/reviu-rekom">
                                                <i className="icon"><SidebarIcon name="review" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Reviu & Rekom Teknis</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cppib/approval' ? 'active' : ''} nav-link`} to="/pbumku/cppib/approval">
                                                <i className="icon"><SidebarIcon name="stamp" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Persetujuan</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cppib/terbit' ? 'active' : ''} nav-link`} to="/pbumku/cppib/terbit">
                                                <i className="icon"><SidebarIcon name="award" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Terbit</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cppib/tolak' ? 'active' : ''} nav-link`} to="/pbumku/cppib/tolak">
                                                <i className="icon"><SidebarIcon name="xCircle" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Tolak</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </Accordion.Collapse>
                            </Accordion.Item>
                            <Accordion.Item as="li" eventKey="sidebar-cpoib" bsPrefix={`nav-item ${active === 'cpoib' ? 'active' : ''} `} onClick={() => setActive('cpoib')}>
                                <CustomToggle eventKey="sidebar-cpoib" active={activeMenu === 'sidebar-cpoib' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                                    <i className="icon"><SidebarIcon name="pill" size={20} /></i>
                                    <span className="item-name">CPOIB</span>
                                    <i className="right-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                        </svg>
                                    </i>
                                </CustomToggle>
                                <Accordion.Collapse eventKey="sidebar-cpoib">
                                    <ul className="sub-nav">
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cpoib/daftar' ? 'active' : ''} nav-link`} to="/pbumku/cpoib/daftar">
                                                <i className="icon"><SidebarIcon name="inbox" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Permohonan (OSS)</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cpoib/inspeksi' ? 'active' : ''} nav-link`} to="/pbumku/cpoib/inspeksi">
                                                <i className="icon"><SidebarIcon name="search" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Inspeksi CPOIB</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cpoib/reviu-rekom' ? 'active' : ''} nav-link`} to="/pbumku/cpoib/reviu-rekom">
                                                <i className="icon"><SidebarIcon name="review" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Reviu & Rekom Teknis</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cpoib/approval' ? 'active' : ''} nav-link`} to="/pbumku/cpoib/approval">
                                                <i className="icon"><SidebarIcon name="stamp" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Persetujuan</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cpoib/terbit' ? 'active' : ''} nav-link`} to="/pbumku/cpoib/terbit">
                                                <i className="icon"><SidebarIcon name="award" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Terbit</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cpoib/tolak' ? 'active' : ''} nav-link`} to="/pbumku/cpoib/tolak">
                                                <i className="icon"><SidebarIcon name="xCircle" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Tolak</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </Accordion.Collapse>
                            </Accordion.Item>
                            <Accordion.Item as="li" eventKey="sidebar-cdoib" bsPrefix={`nav-item ${active === 'cdoib' ? 'active' : ''} `} onClick={() => setActive('cdoib')}>
                                <CustomToggle eventKey="sidebar-cdoib" active={activeMenu === 'sidebar-cdoib' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                                    <i className="icon"><SidebarIcon name="truck" size={20} /></i>
                                    <span className="item-name">CDOIB</span>
                                    <i className="right-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                        </svg>
                                    </i>
                                </CustomToggle>
                                <Accordion.Collapse eventKey="sidebar-cdoib">
                                    <ul className="sub-nav">
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cdoib/daftar' ? 'active' : ''} nav-link`} to="/pbumku/cdoib/daftar">
                                                <i className="icon"><SidebarIcon name="inbox" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Permohonan (OSS)</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cdoib/inspeksi' ? 'active' : ''} nav-link`} to="/pbumku/cdoib/inspeksi">
                                                <i className="icon"><SidebarIcon name="search" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Inspeksi CDOIB</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cdoib/reviu-rekom' ? 'active' : ''} nav-link`} to="/pbumku/cdoib/reviu-rekom">
                                                <i className="icon"><SidebarIcon name="review" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Reviu & Rekom Teknis</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cdoib/approval' ? 'active' : ''} nav-link`} to="/pbumku/cdoib/approval">
                                                <i className="icon"><SidebarIcon name="stamp" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Persetujuan</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cdoib/terbit' ? 'active' : ''} nav-link`} to="/pbumku/cdoib/terbit">
                                                <i className="icon"><SidebarIcon name="award" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Terbit</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cdoib/tolak' ? 'active' : ''} nav-link`} to="/pbumku/cdoib/tolak">
                                                <i className="icon"><SidebarIcon name="xCircle" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Tolak</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </Accordion.Collapse>
                            </Accordion.Item>
                            <Accordion.Item as="li" eventKey="sidebar-kapal-oss" bsPrefix={`nav-item ${active === 'kapal-oss' ? 'active' : ''} `} onClick={() => setActive('kapal-oss')}>
                                <CustomToggle eventKey="sidebar-kapal-oss" active={activeMenu === 'sidebar-kapal-oss' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                                    <i className="icon"><SidebarIcon name="ship" size={20} /></i>
                                    <span className="item-name">CPIB Kapal (OSS)</span>
                                    <i className="right-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                        </svg>
                                    </i>
                                </CustomToggle>
                                <Accordion.Collapse eventKey="sidebar-kapal-oss">
                                    <ul className="sub-nav">
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cpibk/daftar' ? 'active' : ''} nav-link`} to="/pbumku/cpibk/daftar">
                                                <i className="icon"><SidebarIcon name="inbox" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Permohonan (OSS)</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cpibk/inspeksi' ? 'active' : ''} nav-link`} to="/pbumku/cpibk/inspeksi">
                                                <i className="icon"><SidebarIcon name="search" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Inspeksi CPIB Kapal</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cpibk/reviu-rekom' ? 'active' : ''} nav-link`} to="/pbumku/cpibk/reviu-rekom">
                                                <i className="icon"><SidebarIcon name="review" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Reviu & Rekom Teknis</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cpibk/approval' ? 'active' : ''} nav-link`} to="/pbumku/cpibk/approval">
                                                <i className="icon"><SidebarIcon name="stamp" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Persetujuan</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cpibk/terbit' ? 'active' : ''} nav-link`} to="/pbumku/cpibk/terbit">
                                                <i className="icon"><SidebarIcon name="award" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Terbit</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className={`${location.pathname === '/pbumku/cpibk/tolak' ? 'active' : ''} nav-link`} to="/pbumku/cpibk/tolak">
                                                <i className="icon"><SidebarIcon name="xCircle" size={16} /></i>
                                                <i className="sidenav-mini-icon"> B </i>
                                                <span className="item-name">Tolak</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </Accordion.Collapse>
                            </Accordion.Item>
                        </>
                    }
                    <Accordion.Item as="li" eventKey="sidebar-kapal" bsPrefix={`nav-item ${active === 'kapal' ? 'active' : ''} `} onClick={() => setActive('kapal')}>
                        <CustomToggle eventKey="sidebar-kapal" active={activeMenu === 'sidebar-kapal' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                            <i className="icon"><SidebarIcon name="ship" size={20} /></i>
                            <span className="item-name">CPIB Kapal (Non OSS)</span>
                            <i className="right-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                </svg>
                            </i>
                        </CustomToggle>
                        <Accordion.Collapse eventKey="sidebar-kapal">
                            <ul className="sub-nav">
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/pbumku/kapal/draft-kapal' ? 'active' : ''} nav-link`} to="/pbumku/kapal/draft-kapal">
                                        <i className="icon"><SidebarIcon name="fileText" size={16} /></i>
                                        <i className="sidenav-mini-icon"> K </i>
                                        <span className="item-name">Daftar Permohonan</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/pbumku/kapal/evp-kapal' ? 'active' : ''} nav-link`} to="/pbumku/kapal/evp-kapal">
                                        <i className="icon"><SidebarIcon name="clipboardCheck" size={16} /></i>
                                        <i className="sidenav-mini-icon"> P </i>
                                        <span className="item-name">Evaluasi Permohonan</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/pbumku/kapal/inspeksi-kapal' ? 'active' : ''} nav-link`} to="/pbumku/kapal/inspeksi-kapal">
                                        <i className="icon"><SidebarIcon name="search" size={16} /></i>
                                        <i className="sidenav-mini-icon"> P </i>
                                        <span className="item-name">Inspeksi Permohonan</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/pbumku/kapal/evt-kapal' ? 'active' : ''} nav-link`} to="/pbumku/kapal/evt-kapal">
                                        <i className="icon"><SidebarIcon name="review" size={16} /></i>
                                        <i className="sidenav-mini-icon"> P </i>
                                        <span className="item-name">Reviu & Rekom Teknis</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/pbumku/kapal/terbit-kapal' ? 'active' : ''} nav-link`} to="/pbumku/kapal/terbit-kapal">
                                        <i className="icon"><SidebarIcon name="award" size={16} /></i>
                                        <i className="sidenav-mini-icon"> K </i>
                                        <span className="item-name">Terbit Sertifikat</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/pbumku/kapal/reject-kapal' ? 'active' : ''} nav-link`} to="/pbumku/kapal/reject-kapal">
                                        <i className="icon"><SidebarIcon name="xCircle" size={16} /></i>
                                        <i className="sidenav-mini-icon"> T </i>
                                        <span className="item-name">Ditolak / DIbatalkan</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/pbumku/kapal/master-kapal' ? 'active' : ''} nav-link`} to="/pbumku/kapal/master-kapal">
                                        <i className="icon"><SidebarIcon name="ship" size={16} /></i>
                                        <i className="sidenav-mini-icon"> M </i>
                                        <span className="item-name">Master Kapal</span>
                                    </Link>
                                </li>
                            </ul>
                        </Accordion.Collapse>
                    </Accordion.Item>

                </>
                }
                {(role === "4" || role === "5") && <>
                    <li><hr className="hr-horizontal" /></li>
                    <li className="nav-item static-item">
                        <Link className="nav-link static-item disabled" to="#" tabIndex="-1">
                            <span className="default-icon text-secondary">Sertifikasi Primer</span>
                            <span className="mini-icon">-</span>
                        </Link>
                    </li>
                    <Accordion.Item as="li" eventKey="sidebar-kapal" bsPrefix={`nav-item ${active === 'kapal' ? 'active' : ''} `} onClick={() => setActive('kapal')}>
                        <CustomToggle eventKey="sidebar-kapal" active={activeMenu === 'sidebar-kapal' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                            <i className="icon"><SidebarIcon name="ship" size={20} /></i>
                            <span className="item-name">CPIB Kapal (Non OSS)</span>
                            <i className="right-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                </svg>
                            </i>
                        </CustomToggle>
                        <Accordion.Collapse eventKey="sidebar-kapal">
                            <ul className="sub-nav">
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/pbumku/kapal/draft-kapal' ? 'active' : ''} nav-link`} to="/pbumku/kapal/draft-kapal">
                                        <i className="icon"><SidebarIcon name="draft" size={16} /></i>
                                        <i className="sidenav-mini-icon"> K </i>
                                        <span className="item-name">Draft Permohonan</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/pbumku/kapal/onprocess-kapal' ? 'active' : ''} nav-link`} to="/pbumku/kapal/onprocess-kapal">
                                        <i className="icon"><SidebarIcon name="hourglass" size={16} /></i>
                                        <i className="sidenav-mini-icon"> K </i>
                                        <span className="item-name">Dalam Proses</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/pbumku/kapal/terbit-kapal' ? 'active' : ''} nav-link`} to="/pbumku/kapal/terbit-kapal">
                                        <i className="icon"><SidebarIcon name="award" size={16} /></i>
                                        <i className="sidenav-mini-icon"> K </i>
                                        <span className="item-name">Terbit Sertifikat</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/pbumku/kapal/reject-kapal' ? 'active' : ''} nav-link`} to="/pbumku/kapal/reject-kapal">
                                        <i className="icon"><SidebarIcon name="xCircle" size={16} /></i>
                                        <i className="sidenav-mini-icon"> K </i>
                                        <span className="item-name">Ditolak / Dibatalkan</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/pbumku/kapal/master-kapal' ? 'active' : ''} nav-link`} to="/pbumku/kapal/master-kapal">
                                        <i className="icon"><SidebarIcon name="ship" size={16} /></i>
                                        <i className="sidenav-mini-icon"> M </i>
                                        <span className="item-name">Master Kapal</span>
                                    </Link>
                                </li>
                            </ul>
                        </Accordion.Collapse>
                    </Accordion.Item>
                </>
                }
                {
                    (role === "1" || role === "6" || isMandatoryPasca === 'Y') && <>
                        <li><hr className="hr-horizontal" /></li>
                        <li className="nav-item static-item">
                            <Link className="nav-link static-item disabled" to="#" tabIndex="-1">
                                <span className="default-icon text-secondary">Sertifikasi Pasca Panen</span>
                                <span className="mini-icon">-</span>
                            </Link>
                        </li>
                        <Accordion.Item as="li" eventKey="sidebar-spdi" bsPrefix={`nav-item ${active === 'spdi' ? 'active' : ''} `} onClick={() => setActive('spdi')}>
                            <CustomToggle eventKey="sidebar-spdi" active={activeMenu === 'sidebar-spdi' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                                <i className="icon"><SidebarIcon name="warehouse" size={20} /></i>
                                <span className="item-name">SPDI</span>
                                <i className="right-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                    </svg>
                                </i>
                            </CustomToggle>
                            <Accordion.Collapse eventKey="sidebar-spdi">
                                <ul className="sub-nav">
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/pbumku/spdi/daftar' ? 'active' : ''} nav-link`} to="/pbumku/spdi/daftar">
                                            <i className="icon"><SidebarIcon name="inbox" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Permohonan (OSS)</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/pbumku/spdi/inspeksi' ? 'active' : ''} nav-link`} to="/pbumku/spdi/inspeksi">
                                            <i className="icon"><SidebarIcon name="search" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Inspeksi SPDI</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/pbumku/spdi/reviu-rekom' ? 'active' : ''} nav-link`} to="/pbumku/spdi/reviu-rekom">
                                            <i className="icon"><SidebarIcon name="review" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Reviu & Rekom Teknis</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/pbumku/spdi/approval' ? 'active' : ''} nav-link`} to="/pbumku/spdi/approval">
                                            <i className="icon"><SidebarIcon name="stamp" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Persetujuan</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/pbumku/spdi/terbit' ? 'active' : ''} nav-link`} to="/pbumku/spdi/terbit">
                                            <i className="icon"><SidebarIcon name="award" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Terbit</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/pbumku/spdi/tolak' ? 'active' : ''} nav-link`} to="/pbumku/spdi/tolak">
                                            <i className="icon"><SidebarIcon name="xCircle" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Tolak</span>
                                        </Link>
                                    </li>
                                </ul>
                            </Accordion.Collapse>
                        </Accordion.Item>
                        <Accordion.Item as="li" eventKey="sidebar-skp" bsPrefix={`nav-item ${active === 'skp' ? 'active' : ''} `} onClick={() => setActive('skp')}>
                            <CustomToggle eventKey="sidebar-skp" active={activeMenu === 'sidebar-skp' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                                <i className="icon"><SidebarIcon name="factory" size={20} /></i>
                                <span className="item-name">SKP</span>
                                <i className="right-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                    </svg>
                                </i>
                            </CustomToggle>
                            <Accordion.Collapse eventKey="sidebar-skp">
                                <ul className="sub-nav">
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/pbumku/skp/daftar' ? 'active' : ''} nav-link`} to="/pbumku/skp/daftar">
                                            <i className="icon"><SidebarIcon name="inbox" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Permohonan (OSS)</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/pbumku/skp/inspeksi' ? 'active' : ''} nav-link`} to="/pbumku/skp/inspeksi">
                                            <i className="icon"><SidebarIcon name="search" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Inspeksi SKP</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/pbumku/skp/reviu-rekom' ? 'active' : ''} nav-link`} to="/pbumku/skp/reviu-rekom">
                                            <i className="icon"><SidebarIcon name="review" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Reviu & Rekom Teknis</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/pbumku/skp/approval' ? 'active' : ''} nav-link`} to="/pbumku/skp/approval">
                                            <i className="icon"><SidebarIcon name="stamp" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Persetujuan</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/pbumku/skp/terbit' ? 'active' : ''} nav-link`} to="/pbumku/skp/terbit">
                                            <i className="icon"><SidebarIcon name="award" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Terbit</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/pbumku/skp/tolak' ? 'active' : ''} nav-link`} to="/pbumku/skp/tolak">
                                            <i className="icon"><SidebarIcon name="xCircle" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Tolak</span>
                                        </Link>
                                    </li>
                                </ul>
                            </Accordion.Collapse>
                        </Accordion.Item>
                        <Accordion.Item as="li" eventKey="sidebar-haccp" bsPrefix={`nav-item ${active === 'haccp' ? 'active' : ''} `} onClick={() => setActive('haccp')}>
                            <CustomToggle eventKey="sidebar-haccp" active={activeMenu === 'sidebar-haccp' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                                <i className="icon"><SidebarIcon name="shieldCheck" size={20} /></i>
                                <span className="item-name">HACCP</span>
                                <i className="right-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                    </svg>
                                </i>
                            </CustomToggle>
                            <Accordion.Collapse eventKey="sidebar-haccp">
                                <ul className="sub-nav">
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/pbumku/haccp/daftar' ? 'active' : ''} nav-link`} to="/pbumku/haccp/daftar">
                                            <i className="icon"><SidebarIcon name="inbox" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Permohonan (OSS)</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/pbumku/haccp/inspeksi' ? 'active' : ''} nav-link`} to="/pbumku/haccp/inspeksi">
                                            <i className="icon"><SidebarIcon name="search" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Inspeksi HACCP</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/pbumku/haccp/reviu-rekom' ? 'active' : ''} nav-link`} to="/pbumku/haccp/reviu-rekom">
                                            <i className="icon"><SidebarIcon name="review" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Reviu & Rekom Teknis</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/pbumku/haccp/approval' ? 'active' : ''} nav-link`} to="/pbumku/haccp/approval">
                                            <i className="icon"><SidebarIcon name="stamp" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Persetujuan</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/pbumku/haccp/terbit' ? 'active' : ''} nav-link`} to="/pbumku/haccp/terbit">
                                            <i className="icon"><SidebarIcon name="award" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Terbit</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/pbumku/haccp/tolak' ? 'active' : ''} nav-link`} to="/pbumku/haccp/tolak">
                                            <i className="icon"><SidebarIcon name="xCircle" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Tolak</span>
                                        </Link>
                                    </li>
                                </ul>
                            </Accordion.Collapse>
                        </Accordion.Item>
                    </>
                }
                {(role === "4" || role === "5") && <>
                    <li><hr className="hr-horizontal" /></li>
                    <li className="nav-item static-item">
                        <Link className="nav-link static-item disabled" to="#" tabIndex="-1">
                            <span className="default-icon text-secondary">SMKHP</span>
                            <span className="mini-icon">-</span>
                        </Link>
                    </li>
                    <Accordion.Item as="li" eventKey="sidebar-user" bsPrefix={`nav-item ${active === 'user' ? 'active' : ''} `} onClick={() => setActive('user')}>
                        <CustomToggle eventKey="sidebar-user" active={activeMenu === 'sidebar-user' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                            <i className="icon"><SidebarIcon name="fileText" size={20} /></i>
                            <span className="item-name">Daftar Permohonan</span>
                            <i className="right-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                </svg>
                            </i>
                        </CustomToggle>
                        <Accordion.Collapse eventKey="sidebar-user">
                            <ul className="sub-nav">
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/permohonan/ekspor/draft' ? 'active' : ''} nav-link`} to="/permohonan/ekspor/draft">
                                        <i className="icon"><SidebarIcon name="draft" size={16} /></i>
                                        <i className="sidenav-mini-icon"> U </i>
                                        <span className="item-name">Draft</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/permohonan/ekspor/onprocess' ? 'active' : ''} nav-link`} to="/permohonan/ekspor/onprocess">
                                        <i className="icon"><SidebarIcon name="hourglass" size={16} /></i>
                                        <i className="sidenav-mini-icon"> E </i>
                                        <span className="item-name">Dalam Proses</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/permohonan/ekspor/siap-approve' ? 'active' : ''} nav-link`} to="/permohonan/ekspor/siap-approve">
                                        <i className="icon"><SidebarIcon name="stamp" size={16} /></i>
                                        <i className="sidenav-mini-icon"> A </i>
                                        <span className="item-name d-flex align-items-center gap-2">
                                            <span>Siap Disetujui</span>
                                            {approvalUnreadCount > 0 && (
                                                <span className="badge rounded-pill bg-danger" style={{ fontSize: 10 }}>
                                                    {approvalUnreadCount > 99 ? '99+' : approvalUnreadCount}
                                                </span>
                                            )}
                                        </span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/permohonan/ekspor/disetujui' ? 'active' : ''} nav-link`} to="/permohonan/ekspor/disetujui">
                                        <i className="icon"><SidebarIcon name="checkCircle" size={16} /></i>
                                        <i className="sidenav-mini-icon"> U </i>
                                        <span className="item-name">Disetujui</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/permohonan/ekspor/ditolak' ? 'active' : ''} nav-link`} to="/permohonan/ekspor/ditolak">
                                        <i className="icon"><SidebarIcon name="xCircle" size={16} /></i>
                                        <i className="sidenav-mini-icon"> U </i>
                                        <span className="item-name">Ditolak</span>
                                    </Link>
                                </li>
                            </ul>
                        </Accordion.Collapse>
                    </Accordion.Item>
                    <Accordion.Item as="li" eventKey="sidebar-smkhp-all-trader" bsPrefix={`nav-item ${active === 'smkhp-all-trader' ? 'active' : ''} `} onClick={() => setActive('smkhp-all-trader')}>
                        <CustomToggle eventKey="sidebar-smkhp-all-trader" active={activeMenu === 'sidebar-smkhp-all-trader' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                            <i className="icon"><SidebarIcon name="fileAward" size={20} /></i>
                            <span className="item-name">SMKHP Final</span>
                            <i className="right-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                </svg>
                            </i>
                        </CustomToggle>
                        <Accordion.Collapse eventKey="sidebar-smkhp-all-trader" >
                            <ul className="sub-nav">
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/permohonan/ekspor/daftar-smkhp-final-trader' ? 'active' : ''} nav-link`} to="/permohonan/ekspor/daftar-smkhp-final-trader">
                                        <i className="icon"><SidebarIcon name="fileAward" size={16} /></i>
                                        <i className="sidenav-mini-icon"> P </i>
                                        <span className="item-name">SMKHP Final ALL</span>
                                    </Link>
                                </li>
                            </ul>
                        </Accordion.Collapse>
                    </Accordion.Item>
                </>
                }
                {(role === "1" || role === "2" || role === "3" || role === "7") && <>
                    <li><hr className="hr-horizontal" /></li>
                    <li className="nav-item static-item">
                        <Link className="nav-link static-item disabled" to="#" tabIndex="-1">
                            <span className="default-icon text-secondary">SMKHP</span>
                            <span className="mini-icon">-</span>
                        </Link>
                    </li>
                    <Accordion.Item as="li" eventKey="sidebar-form" bsPrefix={`nav-item ${active === 'form' ? 'active' : ''} `} onClick={() => setActive('form')}>
                        <CustomToggle eventKey="sidebar-form" active={activeMenu === 'sidebar-form' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                            <i className="icon"><SidebarIcon name="clipboard" size={20} /></i>
                            <span className="item-name">Penugasan</span>
                            <i className="right-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                </svg>
                            </i>
                        </CustomToggle>
                        <Accordion.Collapse eventKey="sidebar-form" >
                            <ul className="sub-nav">
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/penugasan/daftar' ? 'active' : ''} nav-link`} to="/penugasan/daftar">
                                        <i className="icon"><SidebarIcon name="inbox" size={16} /></i>
                                        <i className="sidenav-mini-icon"> E </i>
                                        <span className="item-name">Permohonan Masuk</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/penugasan/daftar-proses' ? 'active' : ''} nav-link`} to="/penugasan/daftar-proses">
                                        <i className="icon"><SidebarIcon name="hourglass" size={16} /></i>
                                        <i className="sidenav-mini-icon"> EP </i>
                                        <span className="item-name">Siap Diproses</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/penugasan/daftar-ev-admin' ? 'active' : ''} nav-link`} to="/penugasan/daftar-ev-admin">
                                        <i className="icon"><SidebarIcon name="clipboardCheck" size={16} /></i>
                                        <i className="sidenav-mini-icon"> EP </i>
                                        <span className="item-name">Evaluasi Permohonan</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/penugasan/daftar-ev-teknis' ? 'active' : ''} nav-link`} to="/penugasan/daftar-ev-teknis">
                                        <i className="icon"><SidebarIcon name="clipboardCheck" size={16} /></i>
                                        <i className="sidenav-mini-icon"> EP </i>
                                        <span className="item-name">Evaluasi Teknis</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/penugasan/daftar-terbit-draft' ? 'active' : ''} nav-link`} to="/penugasan/daftar-terbit-draft">
                                        <i className="icon"><SidebarIcon name="draft" size={16} /></i>
                                        <i className="sidenav-mini-icon"> EP </i>
                                        <span className="item-name">Draft SMKHP</span>
                                    </Link>
                                </li>
                                {signaturePolicyLoaded && signatureRequired && (
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/signature/pending' ? 'active' : ''} nav-link`} to="/signature/pending">
                                            <i className="icon"><SidebarIcon name="signature" size={16} /></i>
                                            <i className="sidenav-mini-icon">T</i>
                                            <span className="item-name d-flex align-items-center gap-2">
                                                <span>Siap Ditandatangani</span>
                                                {signatureUnreadCount > 0 && (
                                                    <span className="badge rounded-pill bg-danger" style={{ fontSize: 10 }}>
                                                        {signatureUnreadCount > 99 ? '99+' : signatureUnreadCount}
                                                    </span>
                                                )}
                                            </span>
                                        </Link>
                                    </li>
                                )}
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/penugasan/daftar-setuju-draft' ? 'active' : ''} nav-link`} to="/penugasan/daftar-setuju-draft">
                                        <i className="icon"><SidebarIcon name="stamp" size={16} /></i>
                                        <i className="sidenav-mini-icon"> EP </i>
                                        <span className="item-name">Persetujuan SMKHP</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/penugasan/daftar-selesai' ? 'active' : ''} nav-link`} to="/penugasan/daftar-selesai">
                                        <i className="icon"><SidebarIcon name="flagCheck" size={16} /></i>
                                        <i className="sidenav-mini-icon"> E </i>
                                        <span className="item-name">Permohonan Selesai</span>
                                    </Link>
                                </li>
                            </ul>
                        </Accordion.Collapse>
                    </Accordion.Item>
                    <Accordion.Item as="li" eventKey="sidebar-pnbp" bsPrefix={`nav-item ${active === 'pnbp' ? 'active' : ''} `} onClick={() => setActive('pnbp')}>
                        <CustomToggle eventKey="sidebar-pnbp" active={activeMenu === 'sidebar-pnbp' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                            <i className="icon"><SidebarIcon name="coins" size={20} /></i>
                            <span className="item-name">PNBP</span>
                            <i className="right-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                </svg>
                            </i>
                        </CustomToggle>
                        <Accordion.Collapse eventKey="sidebar-pnbp" >
                            <ul className="sub-nav">
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/penugasan/daftar-pnbp-belum-dibuat' ? 'active' : ''} nav-link`} to="/penugasan/daftar-pnbp-belum-dibuat">
                                        <i className="icon"><SidebarIcon name="receipt" size={16} /></i>
                                        <i className="sidenav-mini-icon"> P </i>
                                        <span className="item-name">PNBP Belum Dibuat</span>
                                    </Link>
                                </li>
                            </ul>
                        </Accordion.Collapse>
                        <Accordion.Collapse eventKey="sidebar-pnbp" >
                            <ul className="sub-nav">
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/setting/edit-pnbp' ? 'active' : ''} nav-link`} to="/setting/edit-pnbp">
                                        <i className="icon"><SidebarIcon name="edit" size={16} /></i>
                                        <i className="sidenav-mini-icon"> R </i>
                                        <span className="item-name">Revisi Tarif PNBP</span>
                                    </Link>
                                </li>
                            </ul>
                        </Accordion.Collapse>
                    </Accordion.Item>
                    <Accordion.Item as="li" eventKey="sidebar-smkhp-us" bsPrefix={`nav-item ${active === 'smkhp-us' ? 'active' : ''} `} onClick={() => setActive('smkhp-us')}>
                        <CustomToggle eventKey="sidebar-smkhp-us" active={activeMenu === 'sidebar-smkhp-us' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                            <i className="icon"><SidebarIcon name="fileAward" size={20} /></i>
                            <span className="item-name">SMKHP Final</span>
                            <i className="right-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                </svg>
                            </i>
                        </CustomToggle>
                        <Accordion.Collapse eventKey="sidebar-smkhp-us" >
                            <ul className="sub-nav">
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/penugasan/daftar-smkhp-final-us' ? 'active' : ''} nav-link`} to="/penugasan/daftar-smkhp-final-us">
                                        <i className="icon"><SidebarIcon name="fileText" size={16} /></i>
                                        <i className="sidenav-mini-icon"> P </i>
                                        <span className="item-name">SMKHP Form F</span>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/penugasan/daftar-smkhp-final-all' ? 'active' : ''} nav-link`} to="/penugasan/daftar-smkhp-final-all">
                                        <i className="icon"><SidebarIcon name="fileAward" size={16} /></i>
                                        <i className="sidenav-mini-icon"> P </i>
                                        <span className="item-name">SMKHP Final ALL</span>
                                    </Link>
                                </li>
                                {(role === "1" || role === "2" || role === "3" || role === "6" || role === "7") && (
                                    <>
                                        <li><hr className="hr-horizontal" /></li>
                                        {signaturePolicyLoaded && signatureRequired && (
                                            <li className="nav-item">
                                                <Link
                                                    className={`${location.pathname === '/signature/signed' ? 'active' : ''} nav-link`}
                                                    to="/signature/signed"
                                                >
                                                    <i className="icon"><SidebarIcon name="fileCheck" size={16} /></i>
                                                    <i className="sidenav-mini-icon"> T </i>
                                                    <span className="item-name">Dokumen TTE</span>
                                                </Link>
                                            </li>
                                        )}
                                    </>
                                )}
                            </ul>
                        </Accordion.Collapse>
                    </Accordion.Item>
                </>
                }
                {
                    (role === "10") &&
                    <>
                        <li><hr className="hr-horizontal" /></li>
                        <li className="nav-item static-item">
                            <Link className="nav-link static-item disabled" to="#" tabIndex="-1">
                                <span className="default-icon text-secondary">SMKHP</span>
                                <span className="mini-icon">-</span>
                            </Link>
                        </li>
                        <Accordion.Item as="li" eventKey="sidebar-smkhp-us" bsPrefix={`nav-item ${active === 'smkhp-us' ? 'active' : ''} `} onClick={() => setActive('smkhp-us')}>
                            <CustomToggle eventKey="sidebar-smkhp-us" active={activeMenu === 'sidebar-smkhp-us' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                                <i className="icon"><SidebarIcon name="fileAward" size={20} /></i>
                                <span className="item-name">SMKHP Final</span>
                                <i className="right-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                    </svg>
                                </i>
                            </CustomToggle>
                            <Accordion.Collapse eventKey="sidebar-smkhp-us" >
                                <ul className="sub-nav">
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/penugasan/daftar-smkhp-final-us' ? 'active' : ''} nav-link`} to="/penugasan/daftar-smkhp-final-us">
                                            <i className="icon"><SidebarIcon name="fileText" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">SMKHP Form F</span>
                                        </Link>
                                    </li>
                                </ul>
                            </Accordion.Collapse>
                        </Accordion.Item>
                    </>
                }
                {(role === "4" || role === "5") &&
                    <>
                        <li><hr className="hr-horizontal" /></li>
                        <li className="nav-item static-item">
                            <Link className="nav-link static-item disabled" to="#" tabIndex="-1">
                                <span className="default-icon text-secondary">Layanan Laboratorium <br />& Jasa Lainnya</span>
                                <span className="mini-icon">-</span>
                            </Link>
                        </li>
                        <Accordion.Item as="li" eventKey="sidebar-nonlalin" bsPrefix={`nav-item ${active === 'auth' ? 'active' : ''} `} onClick={() => setActive('auth')}>
                            <CustomToggle eventKey="sidebar-nonlalin" active={activeMenu === 'sidebar-nonlalin' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                                <i className="icon"><SidebarIcon name="flask" size={20} /></i>
                                <span className="item-name">Permohonan</span>
                                <i className="right-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                    </svg>
                                </i>
                            </CustomToggle>
                            <Accordion.Collapse eventKey="sidebar-nonlalin">
                                <ul className="sub-nav">
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/nonlalin/draft' ? 'active' : ''} nav-link`} to="/nonlalin/draft">
                                            <i className="icon"><SidebarIcon name="draft" size={16} /></i>
                                            <i className="sidenav-mini-icon"> D </i>
                                            <span className="item-name">Draft</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/nonlalin/onprocess' ? 'active' : ''} nav-link`} to="/nonlalin/onprocess">
                                            <i className="icon"><SidebarIcon name="send" size={16} /></i>
                                            <i className="sidenav-mini-icon"> T </i>
                                            <span className="item-name">Terkirim</span>
                                        </Link>
                                    </li>
                                </ul>
                            </Accordion.Collapse>
                        </Accordion.Item>
                    </>
                }
                {(role === "1" || role === "2" || role === "3" || role === "7") &&
                    <>
                        <li><hr className="hr-horizontal" /></li>
                        <li className="nav-item static-item">
                            <Link className="nav-link static-item disabled" to="#" tabIndex="-1">
                                <span className="default-icon text-secondary">Layanan Laboratorium <br />& Jasa Lainnya</span>
                                <span className="mini-icon">-</span>
                            </Link>
                        </li>
                        <Accordion.Item as="li" eventKey="sidebar-nll-upt" bsPrefix={`nav-item ${active === 'nll-upt' ? 'active' : ''} `} onClick={() => setActive('nll-upt')}>
                            <CustomToggle eventKey="sidebar-nll-upt" active={activeMenu === 'sidebar-nll-upt' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                                <i className="icon"><SidebarIcon name="building" size={20} /></i>
                                <span className="item-name">Permohonan UPT</span>
                                <i className="right-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                    </svg>
                                </i>
                            </CustomToggle>
                            <Accordion.Collapse eventKey="sidebar-nll-upt">
                                <ul className="sub-nav">
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/nonlalin/draft-upt' ? 'active' : ''} nav-link`} to="/nonlalin/draft-upt">
                                            <i className="icon"><SidebarIcon name="fileText" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Daftar Permohonan</span>
                                        </Link>
                                    </li>
                                </ul>
                            </Accordion.Collapse>
                        </Accordion.Item>
                        <Accordion.Item as="li" eventKey="sidebar-nll" bsPrefix={`nav-item ${active === 'auth' ? 'active' : ''} `} onClick={() => setActive('auth')}>
                            <CustomToggle eventKey="sidebar-nll" active={activeMenu === 'sidebar-nll' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                                <i className="icon"><SidebarIcon name="clipboard" size={20} /></i>
                                <span className="item-name">Penugasan</span>
                                <i className="right-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                    </svg>
                                </i>
                            </CustomToggle>
                            <Accordion.Collapse eventKey="sidebar-nll">
                                <ul className="sub-nav">
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/nonlalin/daftar-masuk' ? 'active' : ''} nav-link`} to="/nonlalin/daftar-masuk">
                                            <i className="icon"><SidebarIcon name="inbox" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Permohonan Masuk</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/nonlalin/daftar-lab' ? 'active' : ''} nav-link`} to="/nonlalin/daftar-lab">
                                            <i className="icon"><SidebarIcon name="flask" size={16} /></i>
                                            <i className="sidenav-mini-icon"> L </i>
                                            <span className="item-name">Laboratorium</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/nonlalin/daftar-scanning' ? 'active' : ''} nav-link`} to="/nonlalin/daftar-scanning">
                                            <i className="icon"><SidebarIcon name="scan" size={16} /></i>
                                            <i className="sidenav-mini-icon"> S </i>
                                            <span className="item-name">Scanning</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/nonlalin/daftar-lainnya' ? 'active' : ''} nav-link`} to="/nonlalin/daftar-lainnya">
                                            <i className="icon"><SidebarIcon name="briefcase" size={16} /></i>
                                            <i className="sidenav-mini-icon"> J </i>
                                            <span className="item-name">Jasa Lainnya</span>
                                        </Link>
                                    </li>
                                </ul>
                            </Accordion.Collapse>
                        </Accordion.Item>
                    </>
                }
                {(role === "1" || role === "2" || role === "3" || role === "9" || role === "7") &&
                    <>
                        <li><hr className="hr-horizontal" /></li>
                        <li className="nav-item static-item">
                            <Link className="nav-link static-item disabled" to="#" tabIndex="-1">
                                <span className="default-icon text-secondary">Layanan Billing Simponi</span>
                                <span className="mini-icon">-</span>
                            </Link>
                        </li>
                        <Accordion.Item as="li" eventKey="sidebar-bill" bsPrefix={`nav-item ${active === 'auth' ? 'active' : ''} `} onClick={() => setActive('auth')}>
                            <CustomToggle eventKey="sidebar-bill" active={activeMenu === 'sidebar-bill' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                                <i className="icon"><SidebarIcon name="receipt" size={20} /></i>
                                <span className="item-name">Billing</span>
                                <i className="right-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                    </svg>
                                </i>
                            </CustomToggle>
                            <Accordion.Collapse eventKey="sidebar-bill">
                                <ul className="sub-nav">
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/billing/daftar-pnbp' ? 'active' : ''} nav-link`} to="/billing/daftar-pnbp">
                                            <i className="icon"><SidebarIcon name="list" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Daftar PNBP</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/billing/daftar' ? 'active' : ''} nav-link`} to="/billing/daftar">
                                            <i className="icon"><SidebarIcon name="receipt" size={16} /></i>
                                            <i className="sidenav-mini-icon"> B </i>
                                            <span className="item-name">Daftar Billing</span>
                                        </Link>
                                    </li>
                                </ul>
                            </Accordion.Collapse>
                        </Accordion.Item>
                    </>
                }
                <li><hr className="hr-horizontal" /></li>
                <li className="nav-item static-item">
                    <Link className="nav-link static-item disabled" to="#" tabIndex="-1">
                        <span className="default-icon  text-secondary">Utilities</span>
                        <span className="mini-icon">-</span>
                    </Link>
                </li>
                {/* {(role === "1" || role === "2" || role === "3" || role === "4" || role === "5") && */}
                <Accordion.Item as="li" eventKey="sidebar-special" bsPrefix={`nav-item ${active === 'special' ? 'active' : ''} `} onClick={() => setActive('special')}>
                    <CustomToggle eventKey="sidebar-special" active={activeMenu === 'sidebar-special' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                        <i className="icon"><SidebarIcon name="database" size={20} /></i>
                        <span className="item-name">Master</span>
                        <i className="right-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                            </svg>
                        </i>
                    </CustomToggle>
                    <Accordion.Collapse eventKey="sidebar-special" >
                        <ul className="sub-nav">
                            <li className="nav-item">
                                <Link className={`${location.pathname === '/setting/upt' ? 'active' : ''} nav-link`} to="/setting/upt">
                                    <i className="icon"><SidebarIcon name="building" size={16} /></i>
                                    <i className="sidenav-mini-icon"> U </i>
                                    <span className="item-name">UPT</span>
                                </Link>
                            </li>
                            {(role === "1" || role === "2" || role === "7") &&
                                <>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/data/pegawai' ? 'active' : ''} nav-link`} to="/data/pegawai">
                                            <i className="icon"><SidebarIcon name="users" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Pegawai</span>
                                        </Link>
                                    </li>

                                </>
                            }
                            {(role === "1" || role === "2" || role === "6" || role === "7") &&
                                <>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/setting/supplier' ? 'active' : ''} nav-link`} to="/setting/supplier">
                                            <i className="icon"><SidebarIcon name="truck" size={16} /></i>
                                            <i className="sidenav-mini-icon"> S </i>
                                            <span className="item-name">Supplier</span>
                                        </Link>
                                    </li>
                                </>
                            }
                            {(role === "4" || role === "5") &&
                                <>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/setting/trader-alamat' ? 'active' : ''} nav-link`} to="/setting/trader-alamat">
                                            <i className="icon"><SidebarIcon name="mapPin" size={16} /></i>
                                            <i className="sidenav-mini-icon"> A </i>
                                            <span className="item-name">Alamat</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/setting/upi' ? 'active' : ''} nav-link`} to="/setting/upi">
                                            <i className="icon"><SidebarIcon name="factory" size={16} /></i>
                                            <i className="sidenav-mini-icon"> U </i>
                                            <span className="item-name">UPI</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/setting/partner' ? 'active' : ''} nav-link`} to="/setting/partner">
                                            <i className="icon"><SidebarIcon name="handshake" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Partner</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/master/ikan' ? 'active' : ''} nav-link`} to="/master/ikan">
                                            <i className="icon"><SidebarIcon name="fish" size={16} /></i>
                                            <i className="sidenav-mini-icon"> C </i>
                                            <span className="item-name">Ikan</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/setting/user-trader' ? 'active' : ''} nav-link`} to="/setting/user-trader">
                                            <i className="icon"><SidebarIcon name="user" size={16} /></i>
                                            <i className="sidenav-mini-icon"> C </i>
                                            <span className="item-name">User</span>
                                        </Link>
                                    </li>
                                </>
                            }
                            {(role === "1" || role === "2" || role === "3" || role === "7") &&
                                <>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/master/satuanikan' ? 'active' : ''} nav-link`} to="/master/satuanikan">
                                            <i className="icon"><SidebarIcon name="scale" size={16} /></i>
                                            <i className="sidenav-mini-icon"> K </i>
                                            <span className="item-name">Satuan Ikan</span>
                                        </Link>
                                    </li>

                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/master/kemasan' ? 'active' : ''} nav-link`} to="/master/kemasan">
                                            <i className="icon"><SidebarIcon name="package" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Kemasan</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/master/hs' ? 'active' : ''} nav-link`} to="/master/hs">
                                            <i className="icon"><SidebarIcon name="hash" size={16} /></i>
                                            <i className="sidenav-mini-icon"> H </i>
                                            <span className="item-name">HS Code</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/master/pelabuhan-pendaratan' ? 'active' : ''} nav-link`} to="/master/pelabuhan-pendaratan">
                                            <i className="icon"><SidebarIcon name="anchor" size={16} /></i>
                                            <i className="sidenav-mini-icon"> PP </i>
                                            <span className="item-name">Pelabuhan Pendaratan</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/master/pelabuhan' ? 'active' : ''} nav-link`} to="/master/pelabuhan">
                                            <i className="icon"><SidebarIcon name="anchor" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Pelabuhan</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/master/tarifpnbp' ? 'active' : ''} nav-link`} to="/master/tarifpnbp">
                                            <i className="icon"><SidebarIcon name="tag" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i>
                                            <span className="item-name">Tarif PNBP</span>
                                        </Link>
                                    </li>
                                </>
                            }
                        </ul>
                    </Accordion.Collapse>
                </Accordion.Item>
                {/* } */}
                {(role === "1" || role === "2" || role === "3" || role === "7") &&
                    <Accordion.Item as="li" eventKey="sidebar-settings" bsPrefix={`nav-item ${active === 'settings' ? 'active' : ''}`} onClick={() => setActive('settings')}>
                        <CustomToggle eventKey="sidebar-settings" active={activeMenu === 'sidebar-settings'} onClick={(activeKey) => setActiveMenu(activeKey)}>
                            <i className="icon"><SidebarIcon name="settings" size={20} /></i>
                            <span className="item-name">Settings</span>
                            <i className="right-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                </svg>
                            </i>
                        </CustomToggle>
                        <Accordion.Collapse eventKey="sidebar-settings">
                            <ul className="sub-nav">
                                <li className="nav-item">
                                    <Link className={`${location.pathname === '/setting/trader' ? 'active' : ''} nav-link`} to="/setting/trader">
                                        <i className="icon"><SidebarIcon name="store" size={16} /></i>
                                        <i className="sidenav-mini-icon"> T </i>
                                        <span className="item-name">Trader</span>
                                    </Link>
                                </li>
                            </ul>
                        </Accordion.Collapse>
                        {role === "1" &&
                            <Accordion.Collapse eventKey="sidebar-settings">
                                <ul className="sub-nav">
                                    <li className="nav-item">
                                        <Link className={`${location.pathname === '/admin/announcements' ? 'active' : ''} nav-link`} to="/admin/announcements">
                                            <i className="icon"><SidebarIcon name="megaphone" size={16} /></i>
                                            <i className="sidenav-mini-icon"> P </i><span className="item-name">Pengumuman</span>
                                        </Link>
                                    </li>
                                </ul>
                            </Accordion.Collapse>
                        }
                    </Accordion.Item>
                }
                {(role === "1" || role === "2" || role === "3" || role === "6" || role === "7" || role === "8" || role === "9") && (
                    <Accordion.Item
                        as="li"
                        eventKey="sidebar-report"
                        bsPrefix={`nav-item ${active === 'report' ? 'active' : ''}`}
                        onClick={() => setActive('report')}
                    >
                        <CustomToggle
                            eventKey="sidebar-report"
                            active={activeMenu === 'sidebar-report'}
                            onClick={(activeKey) => setActiveMenu(activeKey)}
                        >
                            <i className="icon"><SidebarIcon name="report" size={20} /></i>

                            {/* Link ke Aplikasi Report */}
                            <a
                                href={`https://siapmutu.kkp.go.id/api/auth/sso?token=${localStorage.getItem("token")}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`item-name ms-2 nav-link no-after ${activeMenu === 'sidebar-report' ? 'text-white' : ''
                                    }`}
                                onClick={(e) => {
                                    e.stopPropagation(); // ⛔ hentikan event Accordion toggle
                                    setActive('report');
                                    setActiveMenu(
                                        activeMenu === 'sidebar-report' ? null : 'sidebar-report'
                                    );
                                }}
                            >
                                Reporting
                            </a>

                            <i className="right-icon">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M9 5l7 7-7 7"
                                    />
                                </svg>
                            </i>
                        </CustomToggle>
                    </Accordion.Item>
                )}
                <li><hr className="hr-horizontal" /></li>
            </Accordion>
        </Fragment>
    )
})

export default VerticalNav
